"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringEventSchema = void 0;
// TODO: Move all this to the shared lib whenever it's available.
const zod_1 = require("zod");
const ByDaySchema = zod_1.z.enum(["MO", "TU", "WE", "TH", "FR", "SA", "SU"]);
exports.RecurringEventSchema = zod_1.z.object({
    frequency: zod_1.z.enum(["weekly", "daily"]),
    interval: zod_1.z.number().int().positive().optional(),
    byDay: zod_1.z.array(ByDaySchema).optional(),
    excludeDates: zod_1.z.array(zod_1.z.string()).optional(),
    // Maybe one day
    // byMonthDay: z.array(z.number().int().min(1).max(31)).optional(),
    // byMonth: z.array(z.number().int().min(1).max(12)).optional(),
    count: zod_1.z.number().int().positive().optional(),
    until: zod_1.z.date().optional(),
});
//# sourceMappingURL=recurring-event-schema.js.map